import styled from '@emotion/styled';
import { Box, Button, Grid, Table, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import React, { useRef } from 'react'
import Rupee from "../../../../assets/img/profiles/Rupee-Symbol-Black.svg";
import { useReactToPrint } from 'react-to-print';

const PaySlipHappycom = ({ userData }) => {
  const STableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "white",
    },
    // hide last border
    "&:nth-of-type(even)": {
      backgroundColor: "#e6e6fa",
    },
  }));

  const STableCell = styled(TableCell)({
    borderBottomColor: "#000000",
    fontSize: "13px",
    color: "#808080",
  });

  const SNCTableCell = styled(TableCell)({
    borderColor: "#FFFFFF",
    fontSize: "13px",
    color: "#808080",
  });

  const SCTableCell = styled(TableCell)({
    borderBottomColor: "#000000",
    // background: "#a2d8fb",
    // color:"#808080"
  });

  const userPaySlip = userData?.payslips[0] || null

  const earning = [
    {
      "component_name": "Basic",
      "arrears": 0,
      "current": 0,
      "total": userPaySlip?.basic,
      "type": "A"
    },
    {
      "component_name": "HRA",
      "arrears": 0,
      "current": 0,
      "total": userPaySlip?.hra,
      "type": "A"
    },
    {
      "component_name": "Medical Allowance",
      "arrears": 0,
      "current": 0,
      "total": userPaySlip?.medical_allowance,
      "type": "A"
    },
    {
      "component_name": "Conveyance Allowance",
      "arrears": 0,
      "current": 0,
      "total": userPaySlip?.conveyance_allowance,
      "type": "A"
    },
    {
      "component_name": "Special Allowance",
      "arrears": 0,
      "current": 0,
      "total": userPaySlip?.special_allowance,
      "type": "A"
    }
  ]

  const deductions = [
    {
      "component_name": "TDS",
      "arrears": 0,
      "current": 0,
      "total": userPaySlip?.tds,
      "type": "D"
    },
    {
      "component_name": "PT",
      "arrears": 0,
      "current": 0,
      "total": userPaySlip?.pt,
      "type": "D"
    }
  ]

  const getMonthName = (monthNumber) => {
  const months = [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
  ];

  return months[monthNumber - 1] || "";
};


  return (
    <div>
      <Box sx={{ background: "#FFFFFF", borderRadius: "4px", border: '3px solid black' }}>
        <Box
          sx={{
            textAlign: "left",
            // p: 1.5,
            // ml: "auto",
            // mr: "auto",
          }}
        >
          <Box sx={{ minHeight: '70px', background: '#fff0cc', display: 'flex', alignItems: 'end', width: '100%', justifyContent: 'center', borderBottom: '1px solid', position: 'relative' }}>
            <Typography variant="body2">
              <b style={{ fontSize: "16px" }}>
                {userData?.company_name}
              </b>
              <br />

              <img
                src={sessionStorage.getItem("company_logo")}
                alt="Company Logo"
                style={{
                  height: "auto",
                  marginBottom: "8px",
                  height: "40px",
                  width: "auto",
                  marginLeft: "auto",
                  marginRight: "auto", position: 'absolute', top: 10, right: 10
                }}
              />
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center", width: '100%', p: '8px', borderBottom: '1px solid black' }}>
            <Typography variant="body2">
              <b style={{ fontSize: "16px" }}>
                CIN : {userData?.company_cin || 'Company CIN'}
                {/* {payslipData?.user_details?.company_cin || 'Company CIN'} */}
              </b>
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', p: '8px', borderBottom: '3px solid black' }}>
            <b>
              {/* {payslipData?.user_details?.company_address || 'Company Address'} */}{userData?.company_address}
            </b>
          </Box>


          <Box sx={{ textAlign: "center", width: '100%', p: '8px', background: '#ddebf7', borderBottom: '1px solid black' }}>
            <Typography variant="body2">
              <b style={{ fontSize: "16px" }}>
                Payslip for the Month of {getMonthName(userPaySlip?.month)} - {userPaySlip?.year}
                {/* Payslip for the Month of {mo[month?.split("-")?.[1]]}- {month?.split("-")?.[0]} */}

              </b>
            </Typography>
          </Box>

          <Box sx={{ textAlign: "center", width: '100%', height: '35px' }} />

          {/* Employee Details Table */}
          <Box sx={{ width: "100%" }}>
            <TableContainer>
              <Table
                size="small"
                aria-label="employee details"
                sx={{
                  width: "100%", border: "1px solid black",
                  borderCollapse: "collapse", "& td, & th": { border: "1px solid black" },
                }}
              >
                {/* ... (Employee details rows remain exactly the same as in your reference) ... */}
                <STableRow >
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>Employee ID</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {/* {payslipData?.user_details?.employee_id || "-"} */} {userData?.employee_id}
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>Bank Name:</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {/* {payslipData?.user_details?.bank_name} */}
                      {userData?.bankname}
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>PAN</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {/* {payslipData?.user_details?.pan} */}
                      {userData?.pan}
                    </Typography>
                  </SNCTableCell>
                </STableRow>

                <STableRow >
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>Employee Name</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {/* {payslipData?.user_details?.employee_name} */}
                      {userData?.employee_name}
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>A/C</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {/* {payslipData?.user_details?.ac_number} */}
                          {userData?.ac_number}
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>LOP days</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {userPaySlip?.lop_days}
                    </Typography>
                  </SNCTableCell>
                </STableRow>

                <STableRow >
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>Department</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {userData?.department}
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    {/* <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                      <b>UAN</b>
                                    </Typography> */}
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    {/* <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                      {payslipData?.user_details?.uan || 'N/A'}
                                    </Typography> */}
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    {/* <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                      <b>ESI</b>
                                    </Typography> */}
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    {/* <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                                      {payslipData?.user_details?.esi || 'N/A'}
                                    </Typography> */}
                  </SNCTableCell>
                </STableRow>

                <STableRow >
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>Designation</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {userData?.designation}
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>Days in month</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {/* {payslipData?.user_details?.total_working_days} */}
                      {userPaySlip?.days_in_month}
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                </STableRow>

                <STableRow >
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1, }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>Gender</b>
                    </Typography>
                  </SNCTableCell>
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {/* {payslipData?.user_details?.gender || "-"} */}
                         {userData?.gender}
                    </Typography>
                  </SNCTableCell>
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      <b>Paid days</b>
                    </Typography>
                  </SNCTableCell>

                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }}>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#333' }}>
                      {userPaySlip?.paid_days}
                    </Typography>
                  </SNCTableCell>
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                  <SNCTableCell sx={{ width: `${100 / 6}%`, p: 0.75, m: 1 }} />
                </STableRow>
              </Table>
            </TableContainer>
          </Box>
          <br />

          {/* Earnings and Deductions Section */}
          <Box sx={{ height: "100%" }}>
            <TableContainer>
              {/* Earnings and Deductions in two columns */}
              <Table
                size="small"
                aria-label="salary breakdown"
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  borderCollapse: "collapse", "& td, & th": { border: "1px solid black" },
                }}
              >
                {/* Earnings Column */}
                <Table
                  size="small"
                  aria-label="earnings"
                  sx={{
                    width: "50%",

                  }}
                >
                  <STableRow>
                    <SCTableCell>
                      <Typography variant="body2">
                        <b>Particular</b>
                      </Typography>
                    </SCTableCell>
                    <SCTableCell align="right">
                      <Typography variant="body2">
                        <b>Total (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                      </Typography>
                    </SCTableCell>
                  </STableRow>

                  {earning
                    ?.sort((a, b) => {
                      const priority = {
                        Basic: 1,
                        HRA: 2,
                        Conveyance: 3,
                        Medical: 4,
                        Special: 5
                      };

                      const getPriority = (name) => priority[name] || 999; // Others go last

                      return getPriority(a.component_name) - getPriority(b.component_name);
                    })
                    ?.map((ele, index) => (
                      <STableRow key={`earning-${index}`}>
                        <TableCell>
                          <Typography variant="body2">
                            {ele?.component_name || '-'}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body2">
                            {ele?.total?.toFixed(0) || '0'}
                          </Typography>
                        </TableCell>
                      </STableRow>
                    ))}

                </Table>

                {/* Deductions Column */}
                <Table
                  size="small"
                  aria-label="deductions"
                  sx={{ width: "50%" }}
                >
                  <STableRow height="20px">
                    <SCTableCell>
                      <Typography variant="body2">
                        <b>Deduction</b>
                      </Typography>
                    </SCTableCell>
                    <SCTableCell align="right">
                      <Typography variant="body2">
                        <b>Total (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                      </Typography>
                    </SCTableCell>
                  </STableRow>


                  {deductions?.map((ele, index) => (
                    <STableRow key={`deduction-${index}`}>
                      <TableCell>
                        <Typography variant="body2">
                          {ele?.component_name || "-"}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="body2">
                          {ele?.total?.toFixed(0) || "0"}
                        </Typography>
                      </TableCell>
                    </STableRow>
                  ))}
                  {Array.from({
                    length: Math.max(
                      0,
                      (earning?.length || 0) -
                      (deductions?.length || 0)
                    ),
                  }).map((_, index) => (
                    <STableRow key={`deduction-spacer-${index}`} style={{ borderBottom: '0px' }}>
                      <TableCell>
                        <Typography variant="body2">&nbsp;</Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="body2">&nbsp;</Typography>
                      </TableCell>
                    </STableRow>
                  ))}
                </Table>
              </Table>

              {/* Gross Salary and Total Deductions */}
              <Table
                size="small"
                aria-label="totals"
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Table size="small" sx={{ width: "50%" }}>
                  <STableRow>
                    <TableCell>
                      <Typography variant="body2">
                        <b>Gross Salary (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2">
                        {Number(userPaySlip?.gross_salary || 0).toFixed(2)}
                      </Typography>
                    </TableCell>
                  </STableRow>
                </Table>

                <Table size="small" sx={{ width: "50%" }}>
                  <STableRow>
                    <TableCell>
                      <Typography variant="body2">
                        <b>Total Deductions (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2">
                        {/* {payslipData?.user_details?.deduction?.reduce(
                                          (sum, item) => sum + (item?.total || 0),
                                          0
                                        )?.toFixed(0) || "0"} */}
                        {userPaySlip?.total_deductions}
                      </Typography>
                    </TableCell>
                  </STableRow>
                </Table>
              </Table>

              {/* Reimbursement Section */}
              <Table
                size="small"
                aria-label="reimbursement"
                sx={{ width: "100%" }}
              >
                {/* <STableRow>
                                  <TableCell>
                                    <Typography variant="body2">
                                      <b>Reimbursement</b>
                                    </Typography>
                                  </TableCell>
                                  <TableCell />
                                  <TableCell />
                                  <TableCell />
                                </STableRow>

                                {payslipData?.user_details?.reimbursment?.map((ele, index) => (
                                  <STableRow key={`reimbursement-${index}`}>
                                    <TableCell>
                                      <Typography variant="body2">
                                        {ele?.component_name || "-"}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <Typography variant="body2"></Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <Typography variant="body2"></Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <Typography variant="body2">
                                        {ele?.total?.toFixed(0) || "0"}
                                      </Typography>
                                    </TableCell>
                                  </STableRow>
                                ))}

                                <STableRow>
                                  <TableCell>
                                    <Typography variant="body2">
                                      <b>Total Reimbursement (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                                    </Typography>
                                  </TableCell>
                                  <TableCell />
                                  <TableCell />
                                  <TableCell align="right">
                                    <Typography variant="body2">
                                      {payslipData?.user_details?.reimbursment?.reduce(
                                        (sum, item) => sum + (item?.total || 0),
                                        0
                                      )?.toFixed(0) || "0"}
                                    </Typography>
                                  </TableCell>
                                </STableRow> */}

                {/* Net Salary */}
                <STableRow>
                  <TableCell>
                    <Typography variant="body2">
                      <b>Net Salary (<img style={{ width: "10px", height: "10px" }} src={Rupee} />)</b>
                    </Typography>
                  </TableCell>
                  <TableCell />
                  <TableCell />
                  <TableCell align="right">
                    <Typography variant="body2">
                      {/* {(payslipData?.user_details?.net_pay?.toFixed(2)) || "0.00"} */}
                      {userPaySlip?.net_salary}
                    </Typography>
                  </TableCell>
                </STableRow>
              </Table>

              {/* Footer */}
              <div style={{ textAlign: "center", background: '#fff0cc' }}>
                <i>
                  <b>
                    Total Net Payable ₹
                    {/* {Math.round(payslipData?.user_details?.net_pay) || "0"} (
                                    {numberToWords(payslipData?.user_details?.net_pay || 0)}) */}
                    {userPaySlip?.net_salary}
                  </b>
                </i>
                <p>
                  **Total Net Payable = Gross Earnings - Total
                  Deductions + Total Reimbursements
                </p>
                <br />
                <i>
                  <p>
                    **This is a computer generated Payslip, doesn't
                    require signature of the competent Authority**
                  </p>
                </i>
              </div>
              <br />
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </div>
  )
}

export default PaySlipHappycom
